import styles from './pageHeader.module.scss'
import PropTypes from 'prop-types'
import { PageSection } from 'layout/pageSection'
import { Header } from 'layout/header'
import { Container } from 'layout/container'
import { InquirySection } from 'sections/inquirySection'
import { Button } from 'common/button'
import { useModifiers } from 'hooks/useModifiers'
import { DFModal } from 'app/components/common/modal'
import { useEffect, useState } from 'react'
import { clearAllBodyScrollLocks } from 'body-scroll-lock'
import { FeaturesBlock } from 'app/components/pages/landings/featuresBlock'
import { InquiryConfirmation } from 'app/components/common/inquiryForm/inquiryConfirmation'

const PageHeader = ({
  children,
  darkRibbon,
  contentRibbon,
  full,
  className,
  formClassName,
  defaultClass,
}) => {
  const mods = useModifiers(styles, 'pageHeader', { darkRibbon, full })
  const [formIsOpen, setFormIsOpen] = useState(false)
  const [confirmIsOpen, setConfirmIsOpen] = useState(false)

  useEffect(() => clearAllBodyScrollLocks, [])

  const showForm = () => {
    setFormIsOpen(true)
  }

  const closeForm = () => {
    setFormIsOpen(false)
  }

  const showConfirm = () => {
    closeForm()
    setConfirmIsOpen(true)
  }

  const closeConfirm = () => {
    setConfirmIsOpen(false)
  }

  const formModal = (
    <DFModal
      id="InquiryFormModal"
      isOpen={formIsOpen}
      className={`${styles.modal__content} ${styles.modal__form}`}
      contentLabel="Inquiry Form"
      onClose={closeForm}
    >
      <InquirySection
        onConfirm={showConfirm}
        location="inquiryFormModal"
        defaultClass={defaultClass}
      />
    </DFModal>
  )

  const confirmModal = (
    <DFModal
      id="InquiryConfirmFormModal"
      isOpen={confirmIsOpen}
      className={`${styles.modal__content} ${styles.modal__confirm}`}
      contentLabel="Confirm Form"
      onClose={closeConfirm}
    >
      <InquiryConfirmation />
    </DFModal>
  )

  const ReqBtnContainer = ({ className }) => {
    return (
      <Container className={`${styles.pageHeader__formActionContainer} ${className}`}>
        <Button className={`${styles.pageHeader__formAction} `} onClick={showForm}>
          Request a Free Quote
        </Button>
      </Container>
    )
  }

  return (
    <PageSection className={`${styles.pageHeader} ${className} ${mods}`}>
      <Header className={className ? styles.withImage : null} />
      <Container flex={'xl'}>
        <div className={styles.pageHeader__row}>
          <div className={styles.pageHeader__content}>
            <Container className={styles.pageHeader__contentWrapper}>{children}</Container>
            {contentRibbon ? (
              <div className={`${styles.pageHeader__contentRibbon} inverted`}>
                <Container className={styles.pageHeader__contentRibbonBody}>
                  <ReqBtnContainer className={styles.desktop} />
                  {contentRibbon}
                </Container>
              </div>
            ) : (
              ''
            )}
          </div>
          <div className={`${formClassName} ${styles.pageHeader__form}`}>
            <div className={styles.pageHeader__formCard}>
              <InquirySection onConfirm={showConfirm} defaultClass={defaultClass} />
            </div>
          </div>
        </div>
        <ReqBtnContainer className={styles.mobile} />
      </Container>
      <div className={styles.pageHeader__formActionStrip}>
        <Container className={`${styles.pageHeader__contentRibbonUnder} inverted`}>
          <FeaturesBlock />
        </Container>
      </div>
      {formModal}
      {confirmModal}
    </PageSection>
  )
}

PageHeader.propTypes = {
  children: PropTypes.node,
  contentRibbon: PropTypes.node,
  darkRibbon: PropTypes.bool,
  full: PropTypes.bool,
  className: PropTypes.string,
  formClassName: PropTypes.string,
  defaultClass: PropTypes.string,
}

export { PageHeader }
